import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectClientLabelName = (store: StoreSchema) =>
	store.newClientLabel.clientLabel.labelName